import React from "react";
import { useLang } from "../context/LangContext";
import useDocumentTitle from "../hooks/useDocumentTitle";
import InfoLayout from "../components/InfoLayout";

export default function TermsPage() {
  const { t } = useLang();
  useDocumentTitle(t("Termos de Uso · ReiMultiBlog", "Terms of Use · ReiMultiBlog"));
  return (
    <InfoLayout title={t("Termos de Uso", "Terms of Use")} crumb={t("Termos", "Terms")}>
      <p>{t(
        "Ao utilizar o ReiMultiBlog concordas com os termos abaixo.",
        "By using ReiMultiBlog you agree to the terms below.")}</p>
      <h2>{t("Conteúdo", "Content")}</h2>
      <p>{t(
        "O conteúdo é fornecido apenas para fins informativos e reflete experiências e opiniões do autor. Não constitui aconselhamento profissional, legal ou financeiro.",
        "Content is provided for informational purposes only and reflects the author's experiences and opinions. It does not constitute professional, legal or financial advice.")}</p>
      <h2>{t("Propriedade intelectual", "Intellectual property")}</h2>
      <p>{t(
        "Os textos e materiais são propriedade do ReiMultiBlog, salvo indicação em contrário. A reprodução sem autorização não é permitida.",
        "Texts and materials are the property of ReiMultiBlog unless otherwise stated. Reproduction without permission is not allowed.")}</p>
      <h2>{t("Responsabilidade", "Liability")}</h2>
      <p>{t(
        "O autor não se responsabiliza por decisões tomadas com base no conteúdo do site.",
        "The author is not liable for decisions made based on the site's content.")}</p>
    </InfoLayout>
  );
}
